import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _regeneratorRuntime from "@babel/runtime/regenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { GlobalErrorsManager } from '@tokamakjs/common';
import { DiContainer } from '@tokamakjs/injection';
import React, { createContext } from 'react';
import ReactDom from 'react-dom';
import urljoin from 'url-join';
import { DiContainerProvider } from './components';
import { BrowserRouter, HashRouter, MemoryRouter, buildRoutes, useRoutes } from './routing';
var HISTORY_MODE_MAP = {
  browser: BrowserRouter,
  hash: HashRouter,
  memory: MemoryRouter
};
export var AppContext = /*#__PURE__*/createContext({});
export var PathsContext = /*#__PURE__*/createContext([]);
export var ErrorsContext = /*#__PURE__*/createContext(undefined);
export var TokamakApp = /*#__PURE__*/function () {
  function TokamakApp(_container, RootApp, _config) {
    _classCallCheck(this, TokamakApp);

    this._container = _container;
    this._config = _config;
    this._paths = [];
    var routes = buildRoutes(RootApp, _container);
    this._paths = this._extractPathsFromRoutes(routes);

    this._RootNode = function () {
      return useRoutes(routes);
    };

    this._Router = HISTORY_MODE_MAP[_config.historyMode];
    this._globalErrorsManager = new GlobalErrorsManager();
  }

  _createClass(TokamakApp, [{
    key: "render",
    value: function render(selector) {
      var appContext = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var RootNode = this._RootNode;
      var Router = this._Router;
      ReactDom.render( /*#__PURE__*/React.createElement(ErrorsContext.Provider, {
        value: this._globalErrorsManager
      }, /*#__PURE__*/React.createElement(Router, {
        basename: this._config.basePath
      }, /*#__PURE__*/React.createElement(DiContainerProvider, {
        value: this._container
      }, /*#__PURE__*/React.createElement(AppContext.Provider, {
        value: appContext
      }, /*#__PURE__*/React.createElement(PathsContext.Provider, {
        value: this._paths
      }, /*#__PURE__*/React.createElement(RootNode, null)))))), document.querySelector(selector));
    }
  }, {
    key: "_extractPathsFromRoutes",
    value: function _extractPathsFromRoutes(routes) {
      var _this = this;

      var parentPath = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      return routes.reduce(function (memo, route) {
        var _route$children;

        if (route.path == null) return memo;
        return [].concat(_toConsumableArray(memo), [urljoin(parentPath, route.path)], _toConsumableArray(_this._extractPathsFromRoutes((_route$children = route.children) !== null && _route$children !== void 0 ? _route$children : [], route.path)));
      }, []);
    }
  }], [{
    key: "create",
    value: function () {
      var _create = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(RootApp) {
        var partialConfig,
            _historyMode$basePath,
            globalProviders,
            config,
            container,
            _args = arguments;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                partialConfig = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
                _historyMode$basePath = _objectSpread({
                  historyMode: 'browser',
                  basePath: '',
                  globalProviders: []
                }, partialConfig), globalProviders = _historyMode$basePath.globalProviders, config = _objectWithoutProperties(_historyMode$basePath, ["globalProviders"]);
                _context.next = 4;
                return DiContainer.from(RootApp, {
                  globalProviders: globalProviders
                });

              case 4:
                container = _context.sent;
                return _context.abrupt("return", new TokamakApp(container, RootApp, config));

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function create(_x) {
        return _create.apply(this, arguments);
      }

      return create;
    }()
  }]);

  return TokamakApp;
}();